<template>
  <div class="service-detail">
    <ServicesServiceHero
      title="Application Development"
      description="Custom software solutions that transform ideas into powerful, scalable applications"
      icon="💻"
      gradient="application-development"
    />

      <!-- Main Content -->
      <div class="container" style="max-width: 1000px;">
        <div class="row">
          <div class="col-md-12">
            <div class="service-main-card">
              <h2 style="color: #1a202c; font-weight: 700; margin-bottom: 24px; font-size: 2.2rem;">Building Tomorrow's Solutions Today 🚀</h2>
              <p style="color: #4a5568; line-height: 1.7; font-size: 1.1rem; margin-bottom: 40px;">In today's digital landscape, powerful applications are the backbone of successful businesses. Our application development team combines technical expertise with creative problem-solving to deliver custom software solutions that drive growth, efficiency, and innovation for your organization.</p>
              
              <h3 style="color: #1a202c; font-weight: 600; margin-bottom: 30px; font-size: 1.8rem;">Our Development Approach</h3>
              <div class="row">
                <div class="col-md-6 mb-4">
                  <div style="background: #f7fafc; padding: 24px; border-radius: 12px; border-left: 4px solid var(--application-development-start); height: 100%;">
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">🔍 Discovery & Planning</h4>
                    <p style="color: #4a5568; margin: 0; line-height: 1.6;">We start by understanding your business goals, user needs, and technical requirements</p>
                  </div>
                </div>
                <div class="col-md-6 mb-4">
                  <div style="background: #f7fafc; padding: 24px; border-radius: 12px; border-left: 4px solid var(--application-development-start); height: 100%;">
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">📐 Design & Architecture</h4>
                    <p style="color: #4a5568; margin: 0; line-height: 1.6;">Creating intuitive interfaces and robust technical foundations</p>
                  </div>
                </div>
                <div class="col-md-6 mb-4">
                  <div style="background: #f7fafc; padding: 24px; border-radius: 12px; border-left: 4px solid var(--application-development-start); height: 100%;">
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">⚙️ Development & Testing</h4>
                    <p style="color: #4a5568; margin: 0; line-height: 1.6;">Agile development with continuous testing and quality assurance</p>
                  </div>
                </div>
                <div class="col-md-6 mb-4">
                  <div style="background: #f7fafc; padding: 24px; border-radius: 12px; border-left: 4px solid var(--application-development-start); height: 100%;">
                    <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px;">🚀 Deployment & Support</h4>
                    <p style="color: #4a5568; margin: 0; line-height: 1.6;">Smooth launch with ongoing maintenance and enhancement</p>
                  </div>
                </div>
              </div>

              <h3 style="color: #1a202c; font-weight: 600; margin-bottom: 30px; margin-top: 50px; font-size: 1.8rem;">Development Expertise</h3>
              
              <div class="row">
                <div class="col-md-6 mb-4">
                  <div style="background: linear-gradient(135deg, var(--application-development-start) 0%, var(--application-development-end) 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                    <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">🌐 Web Applications</h4>
                    <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                      <li>Progressive Web Apps (PWAs)</li>
                      <li>Single Page Applications (SPAs)</li>
                      <li>E-commerce Platforms</li>
                      <li>Content Management Systems</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6 mb-4">
                  <div style="background: linear-gradient(135deg, var(--application-development-start) 0%, var(--application-development-end) 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                    <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">📱 Mobile Development</h4>
                    <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                      <li>Native iOS Applications</li>
                      <li>Native Android Applications</li>
                      <li>Cross-platform Solutions</li>
                      <li>Mobile-first Experiences</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6 mb-4">
                  <div style="background: linear-gradient(135deg, var(--application-development-start) 0%, var(--application-development-end) 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                    <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">🧩 API Development</h4>
                    <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                      <li>RESTful API Design</li>
                      <li>GraphQL Implementation</li>
                      <li>Microservices Architecture</li>
                      <li>Third-party Integrations</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6 mb-4">
                  <div style="background: linear-gradient(135deg, var(--application-development-start) 0%, var(--application-development-end) 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                    <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">🔧 Enterprise Solutions</h4>
                    <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                      <li>Custom CRM Systems</li>
                      <li>Business Intelligence Tools</li>
                      <li>Workflow Automation</li>
                      <li>Legacy System Modernization</li>
                    </ul>
                  </div>
                </div>
              </div>

              <h3 style="color: #1a202c; font-weight: 600; margin-bottom: 30px; margin-top: 50px; font-size: 1.8rem;">Technologies We Use</h3>
              
              <div style="background: #f7fafc; padding: 40px; border-radius: 16px; margin-bottom: 40px;">
                <div class="row">
                  <div class="col-md-4 mb-4">
                    <div style="text-align: center;">
                      <h5 style="color: #1a202c; font-weight: 600; margin-bottom: 16px;">Frontend</h5>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6;">React, Vue.js, Angular, Next.js, Nuxt.js, TypeScript, Tailwind CSS</p>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div style="text-align: center;">
                      <h5 style="color: #1a202c; font-weight: 600; margin-bottom: 16px;">Backend</h5>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6;">Node.js, Python, Java, .NET, PHP, Ruby on Rails, Go</p>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div style="text-align: center;">
                      <h5 style="color: #1a202c; font-weight: 600; margin-bottom: 16px;">Mobile</h5>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6;">Swift, Kotlin, React Native, Flutter, Ionic</p>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div style="text-align: center;">
                      <h5 style="color: #1a202c; font-weight: 600; margin-bottom: 16px;">Databases</h5>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6;">PostgreSQL, MySQL, MongoDB, Redis, DynamoDB</p>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div style="text-align: center;">
                      <h5 style="color: #1a202c; font-weight: 600; margin-bottom: 16px;">Cloud</h5>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6;">AWS, Azure, Google Cloud, Serverless</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div style="text-align: center;">
                      <h5 style="color: #1a202c; font-weight: 600; margin-bottom: 16px;">DevOps</h5>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6;">Docker, Kubernetes, CI/CD, Terraform</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Pricing Section -->
              <div style="background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%); padding: 40px; border-radius: 16px; margin-top: 50px; border-left: 4px solid #3b82f6; text-align: center;">
                <h3 style="color: #1a202c; font-weight: 700; margin-bottom: 16px; font-size: 1.8rem;">Transparent Pricing</h3>
                <p style="color: #4a5568; font-size: 1.1rem; line-height: 1.7; margin-bottom: 24px; max-width: 700px; margin-left: auto; margin-right: auto;">
                  Standard rate of <strong style="color: #1a202c; font-size: 1.2rem;">$225/hour</strong> for consulting and implementation. Volume discounts and retainer packages available.
                </p>
                <NuxtLink to="/services/pricing" style="display: inline-block; background: #3b82f6; color: white; padding: 14px 32px; border-radius: 8px; font-weight: 600; text-decoration: none; font-size: 1.05rem; transition: background 0.2s;">
                  View Full Pricing Details
                </NuxtLink>
              </div>

              <div style="background: linear-gradient(135deg, var(--application-development-start) 0%, var(--application-development-end) 100%); color: white; padding: 40px; border-radius: 16px; margin-top: 50px; text-align: center;">
                <h3 style="font-weight: 700; margin-bottom: 20px; font-size: 1.8rem;">Let's Build Something Amazing Together</h3>
                <p style="font-size: 1.1rem; opacity: 0.95; line-height: 1.6; margin-bottom: 30px;">Whether you need a customer-facing application or an internal tool to streamline operations, our development team is ready to turn your vision into reality.</p>
                <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
                  <div style="background: rgba(255,255,255,0.2); padding: 20px; border-radius: 12px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.3); flex: 1; min-width: 200px; max-width: 250px;">
                    <h4 style="font-weight: 600; margin-bottom: 12px;">💡 Startups</h4>
                    <p style="margin: 0; font-size: 0.95rem; opacity: 0.9;">MVP development and scaling</p>
                  </div>
                  <div style="background: rgba(255,255,255,0.2); padding: 20px; border-radius: 12px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.3); flex: 1; min-width: 200px; max-width: 250px;">
                    <h4 style="font-weight: 600; margin-bottom: 12px;">🏢 Enterprises</h4>
                    <p style="margin: 0; font-size: 0.95rem; opacity: 0.9;">Custom enterprise solutions</p>
                  </div>
                  <div style="background: rgba(255,255,255,0.2); padding: 20px; border-radius: 12px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.3); flex: 1; min-width: 200px; max-width: 250px;">
                    <h4 style="font-weight: 600; margin-bottom: 12px;">🛒 E-commerce</h4>
                    <p style="margin: 0; font-size: 0.95rem; opacity: 0.9;">Online store development</p>
                  </div>
                </div>
                <p style="margin-top: 30px; margin-bottom: 0; font-style: italic; opacity: 0.9;">From concept to deployment, we're with you every step of the way.</p>
              </div>
            </div>
          </div>
      
  
    </div>
  </div>
  </div>
  
</template>

<script setup>
useHead({
  title: 'Application Development | Geek Cafe',
  meta: [
    { name: 'description', content: 'Custom application development services by Geek Cafe. Scalable, secure, and tailored software solutions for your business.' }
  ]
})
</script>

<style scoped src="@/assets/css/service-detail-card.css"></style>
